import { Formik } from 'formik';
import { validationSchemaArticle, initValuesArticle } from './createArticleValidation';
import Form from "./ArticleForm";
import { useAxios } from "../../../../context/AxiosHookContext";

const FormCreateTicket = ({ onClose, valuesToEdit, getValues }) => {


    const getInitialValues = () => {
        return (valuesToEdit && Object.keys(valuesToEdit).length) > 0 ? valuesToEdit : initValuesArticle
    }

    const axios = useAxios();

    const handleSubmit = async (article) => {

        try {
            let result;

            if (article._id) {

                result = await axios.put(`/inventory/update/${article._id}`, article)

            } else {
                result = await axios.post("/inventory/create", article);
            }

        } catch (error) {
            console.log(error)
        } finally {
         getValues();
        }

    }

    return (
        <Formik
            validationSchema={validationSchemaArticle}
            initialValues={getInitialValues()}
            onSubmit={handleSubmit}
            validateOnBlur={true}  // Muestra errores cuando el usuario sale del input
            validateOnChange={true} // Valida mientras escribe
            validateOnMount={true}
        >
            <Form onClose={() => { getValues(); onClose() }} />
        </Formik>
    )
}

export default FormCreateTicket